import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DropdownItem } from "@flowtribe/ui";
import { StepCondition } from "../../../interfaces/review-workflow.interface";
import { availableConditionOptions, isConditionValueBlocked } from "../../../utils/step-condition.util";

/** Deleting a row is immediate, with no confirmation. */
@Component({
  standalone: false,
  selector: "app-step-start-condition-row",
  templateUrl: "./step-start-condition-row.component.html"
})
export class StepStartConditionRowComponent implements OnChanges {
  @Input() condition!: StepCondition;
  /** Values of all rows, this one included. */
  @Input() takenValues: string[] = [];
  @Input() hasCustomerAcceptance = false;

  @Output() conditionChange = new EventEmitter<StepCondition>();
  @Output() remove = new EventEmitter<void>();

  constructor(private readonly translateService: TranslateService) {}

  /** Rebuilt in ngOnChanges, never a getter — a getter rebuilds `ui-dropdown`'s menu every tick and it won't stay open. */
  conditionItems: DropdownItem<StepCondition>[] = [];
  selectedConditionItem?: DropdownItem<StepCondition>;

  ngOnChanges(): void {
    const siblingValues = this.takenValues.filter(value => value !== this.condition.value);

    // The row's own value is never disabled, so a saved conflicting pair still shows.
    this.conditionItems = availableConditionOptions(this.hasCustomerAcceptance, this.condition.value)
      .map(option => ({
        name: this.translateService.instant(option.labelKey),
        item: { field: option.field, value: option.value },
        disabled: option.value !== this.condition.value && isConditionValueBlocked(option.value, siblingValues),
        disabledTooltipMessage: this.translateService.instant("review-workflow.Condition_option_unavailable")
      }))
      .sort((a, b) => a.name.localeCompare(b.name));

    this.selectedConditionItem = this.conditionItems.find(item => item.item.value === this.condition.value);
  }

  onConditionSelected(item: DropdownItem<StepCondition>): void {
    this.conditionChange.emit(item.item);
  }
}
